"use strict";var e=require("./base.js"),s=require("../core/holder.js");require("../core/change-details.js");class r extends e{_update(e){e.mask&&(e.validate=s=>s.search(e.mask)>=0),super._update(e)}}s.MaskedRegExp=r,module.exports=r;
//# sourceMappingURL=regexp.js.map
